import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import GalleryLayout from 'layouts/GalleryLayout';
import renderLoaders from 'utils/renderLoaders';

export default function Gallery() {
  const router = useRouter();

  useEffect(() => {
    router.push('/illustrations');
  }, []);

  return <GalleryLayout>{renderLoaders()}</GalleryLayout>;
}
